
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.19 5.166c.875.047 1.654.32 2.26.96.205.214.273.163.386-.074.526-1.106 1.076-2.202 1.599-3.31.13-.275.274-.29.528-.173 1.69.774 3.385 1.54 5.086 2.298.298.133.35.266.216.556a1171.03 1171.03 0 00-3.31 7.155c-.353.77-.832 1.428-1.61 1.835-1.25.654-2.709.466-3.73-.495-.215-.2-.301-.187-.425.07-.521 1.085-1.065 2.16-1.583 3.245-.13.272-.267.332-.548.2-1.703-.78-3.409-1.55-5.118-2.313-.282-.125-.336-.25-.206-.528A1146.03 1146.03 0 005.051 7.44c.301-.658.65-1.263 1.276-1.69.561-.38 1.186-.551 1.863-.584z","fill":"#0089C7"}})])
          )
        }
      }
    